"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * * @param {string} schoolId the school id
 * Throw when user is not part of school and therefore does not have access to school data
 */
class ForbiddenSchoolAccessError extends client_library_1.ExtendableError {
    constructor(schoolId) {
        super(`You do not have access to this school: ${schoolId}`);
        this.schoolId = schoolId;
    }
}
exports.default = ForbiddenSchoolAccessError;
//# sourceMappingURL=ForbiddenSchoolAccessError.js.map